import {YascEntityMapperV3} from '@yasc/yasc-material-components';
import {ContactPersonCreateReq, ContactPersonDetailRes, ContactPersonUpdateReq} from './user.contract';
import {ContactPerson} from './contact-person.model';

export class ContactPersonMapper
    implements YascEntityMapperV3<ContactPersonDetailRes, ContactPersonDetailRes, ContactPerson, ContactPersonCreateReq, ContactPersonUpdateReq, number> {
    readonly modelTypes = {
        row: ContactPersonDetailRes,
        detail: ContactPersonDetailRes,
        domain: ContactPerson,
        create: ContactPersonCreateReq,
        patch: ContactPersonUpdateReq,
    };

    readonly idKey = 'id' as const;

    fromMinResponse(response: ContactPersonDetailRes): ContactPerson {
        return this.fromResponse(response);
    }

    fromDetailResponse(response: ContactPersonDetailRes): ContactPerson {
        return this.fromResponse(response);
    }

    toCreateRequest(domain: ContactPerson): ContactPersonCreateReq {
        return this.fillRequest(new ContactPersonCreateReq(), domain);
    }

    toPatchRequest(domain: ContactPerson): ContactPersonUpdateReq {
        const request = this.fillRequest(new ContactPersonUpdateReq(), domain);
        request.id = domain.id;
        return request;
    }

    createEmptyDomain(): ContactPerson {
        return new ContactPerson();
    }

    getKey(domain: ContactPerson): number {
        return domain.id;
    }

    private fromResponse(response: ContactPersonDetailRes): ContactPerson {
        return new ContactPerson({
            id: response.id,
            title: response.title ?? '',
            salutation: response.salutations ?? 0,
            firstName: response.firstName ?? '',
            lastName: response.lastName ?? '',
            email: response.email ?? '',
            phone: response.phone ?? '',
            mobile: response.mobile ?? '',
            department: response.department ?? '',
            companyId: response.companyId ?? null,
            companyName: response.companyName ?? '',
        });
    }

    private fillRequest<T extends ContactPersonCreateReq>(request: T, domain: ContactPerson): T {
        request.title = domain.title ?? '';
        request.firstName = domain.firstName ?? '';
        request.lastName = domain.lastName ?? '';
        request.salutation = domain.salutation ?? 0;
        request.email = domain.email ?? '';
        request.phone = domain.phone ?? '';
        request.mobile = domain.mobile ?? '';
        request.department = domain.department ?? '';
        request.companyId = domain.companyId ?? 0;
        request.companyName = domain.companyName ?? '';
        return request;
    }
}
